<template>
    <div>
        <b-table-simple>
            <b-thead>
            </b-thead>
            <b-tbody>
                <b-tr>
                    <b-td style="width:30%;">파이프라인 사용 여부</b-td>
                    <b-td>
                        <b-dropdown :text="pipeline_enabled? '사용' : '사용하지 않음'">
                            <b-dropdown-item @click="enablePipeline(true)">사용</b-dropdown-item>
                            <b-dropdown-item @click="enablePipeline(false)">사용하지 않음</b-dropdown-item>
                        </b-dropdown>
                    </b-td>
                </b-tr>
                <b-tr v-if="pipeline_enabled==true">
                    <b-td>대상 SubCode</b-td><b-td><b-form-input v-model="pipeline_sub_code"></b-form-input></b-td>
                </b-tr>
                <b-tr v-if="pipeline_enabled==true">
                    <b-td>상세조건</b-td><b-td><b-form-textarea v-model="condition" max-rows="10" ></b-form-textarea></b-td>
                </b-tr>
                <b-tr v-if="pipeline_enabled==true">
                    <b-td col-span="2">조건이 참일 경우 해당 질문을 
                    </b-td>
                    <b-td>
                        <b-dropdown :text="satisfied_visible? '표시함' : '표시하지 않음'">
                            <b-dropdown-item @click="satisfied_visible=true">표시함</b-dropdown-item>
                            <b-dropdown-item @click="satisfied_visible=false">표시하지 않음</b-dropdown-item>
                        </b-dropdown>
                    </b-td>
                </b-tr>
                <b-tr v-if="pipeline_enabled==true">
                    <b-td col-span="2">질문이 표시되지 않는 경우 해당 질문을 
                    </b-td>
                    <b-td>
                        <b-dropdown :text="invisible_not_applicable? '해당없음 처리' : '0점 처리'">
                            <b-dropdown-item @click="invisible_not_applicable=true">해당없음 처리</b-dropdown-item>
                            <b-dropdown-item @click="invisible_not_applicable=false">0점 처리</b-dropdown-item>
                        </b-dropdown>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <div class="text-right">
            <b-button variant="blue" class="mr-2" :disabled="is_saving" @click="handleSave">
                <b-spinner v-show="is_saving" small class="mr-1" />저장
            </b-button>
            <b-button variant="dark" @click="$emit('click-cancel')">취소</b-button>
        </div> 
    </div>
</template>

<script>
import { getErrorMessage } from '@core/utils/api/errorMessage';

export default {
    name: "EditingPipeline",
    props: {
        sub_code: {
            type: String,
            default: ''
        },
        sub_type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            pipeline_enabled: false,
            has_saved_pipeline: false,
            is_saving: false,
            pipeline_sub_code: '',
            condition: '',
            satisfied_visible: false,
            invisible_not_applicable: true
        }
    },
    async created () {
        await this.readPipeline()
    },
    methods:{
        async readPipeline () {
            try {
                const response = await this.$axios.get('/read_pipeline', {
                    params: { sub_code: this.sub_code }
                })

                console.log(response)
                if (response.data) {
                    this.pipeline_enabled = true
                    this.has_saved_pipeline = true
                }
                this.pipeline_sub_code = response.data.pipeline_sub_code
                this.condition = response.data.condition
                this.satisfied_visible = response.data.satisfied_visible
                this.invisible_not_applicable = response.data.invisible_not_applicable   
            } catch (error) {
                console.log(error);
            }
        },
        async handleSave () {
            if (this.is_saving) return
            try {
                this.is_saving = true
                if (this.pipeline_enabled === false) {
                    if (!this.has_saved_pipeline) {
                        return this.$EventBus.$emit('toast-warning', '저장할 내용 없음', '설정된 파이프라인이 없습니다.')
                    }
                    const ok = await this.$showModal({
                        type: 'confirm',
                        state: 'warning',
                        title: '파이프라인 삭제',
                        message: `문항 ${this.sub_code} 에 설정된 파이프라인(표시 조건)이 삭제됩니다. 계속하시겠습니까?`
                    })
                    if (!ok) return
                    await this.deletePipeline()
                    this.has_saved_pipeline = false
                    this.$EventBus.$emit('toast-success', '성공', '파이프라인을 삭제하였습니다.')
                } else {
                    if (!(this.pipeline_sub_code || '').trim() || !(this.condition || '').trim()) {
                        return this.$EventBus.$emit('toast-warning', '입력 확인', '대상 SubCode 와 상세조건을 입력해야 합니다.')
                    }
                    await this.savePipeline()
                }
            } catch (error) {
                this.$EventBus.$emit('toast-failure', '파이프라인 저장 실패', getErrorMessage(error, '저장하지 못했습니다. 다시 시도해주세요.'))
            } finally {
                this.is_saving = false
            }
        },
        async deletePipeline () {
            const formData = new FormData()
            formData.append('sub_code', this.sub_code)
            await this.$axios.post('/delete_pipeline', formData)
            // const path = this.$store.state.backend_host + '/delete_pipeline'

            // const formData = new FormData()
            // formData.append('sub_code', this.sub_code)

            // return axios.post(path, formData)
        },
        async savePipeline () {
            {
                const formData = new FormData()
                formData.append('sub_code', this.sub_code)
                formData.append('pipeline_sub_code', this.pipeline_sub_code)
                formData.append('condition', this.condition)
                formData.append('satisfied_visible', this.satisfied_visible )
                formData.append('invisible_not_applicable', this.invisible_not_applicable)

                const response = await this.$axios.post('/save_pipeline', formData)
                console.log(response)
                this.has_saved_pipeline = true
                this.$EventBus.$emit('toast-success','성공','질문 숨김/표시 조건을 저장하였습니다.')
            }
        
            // const path = this.$store.state.backend_host + '/save_pipeline'
                   
            // const formData = new FormData()
            // formData.append('sub_code', this.sub_code)
            // formData.append('pipeline_sub_code', this.pipeline_sub_code)
            // formData.append('condition', this.condition)
            // formData.append('satisfied_visible', this.satisfied_visible )
            // formData.append('invisible_not_applicable', this.invisible_not_applicable)

            // return axios.post(path, formData)
            // .then(response => {
            //     console.log(response)
            //     this.$emit('toast-success','성공','질문 숨김/표시 조건을 저장하였습니다.')               
            // })
            // .catch(error => {
            //     console.log(error)
            // })
        },
        enablePipeline(target){
            if(target==true){
                this.pipeline_enabled = true
            }
            else{
                this.pipeline_enabled = false
                this.pipeline_sub_code = ''
                this.condition = ''
                this.satisfied_visible = false,
                this.invisible_not_applicable = true
            }
        }

    }
}
</script>

<style>
/* #structure-preview > .card-header {
    padding: 0.25rem 1.25rem;
} */
#structure-preview > .card-body > .table td{
    text-align: left;
}
</style>